<template>
	<div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%" height='calc(100vh - 180px)'>
				<el-table-column type="index" label="#" width='50px'></el-table-column>
				<el-table-column prop="detail.name" label="姓名" width="150"></el-table-column>
				<el-table-column prop="codeNo" label="序列号" align='center' width="150"></el-table-column>
				<el-table-column prop="detail.code" label="卡号"></el-table-column>
				<el-table-column prop="product.name" label="产品名称">
				</el-table-column>
				<el-table-column label="出单时间" width='180px'>
					<template slot-scope="scope">{{ setTime(scope.row.detail.updateAt) }}</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<router-link class="blue" :to="{path:'/shop/activation',query:{code:scope.row.detail.code}}">查看详情</router-link>&nbsp;&nbsp;&nbsp;
						<router-link class="blue" :to="{path:'/commodity/statisticalDetail?',query:{id:scope.row.product.id}}">查看批次统计</router-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<pages class='pagination' :allpage='allpage' :changePage='changePage'></pages>
		</div>
	</div>
</template>

<script>
	import common from '@/assets/common.js'
	import { entityDetailList } from '@/axios/api.js'
	export default{
		data() {
			return {
				tableData: [],
				allpage:10
			}
		},
		mounted(){
			this.getData()
		},
		methods: {
			changePage(start,count){
				this.getData(start,count)
			},
			setTime(str) {
				return common.time(str)
			},
			getData(start,count) {
				var start=start || 0;//当前页
				var count=count || 10;//每页多少个
				var data={
					isActive:1,
					start,
					count
				}
				entityDetailList(data)
				.then( res => {
				    console.log(res);
					this.tableData=res.data.obj
					this.allpage=res.data.total;
				})
				.catch(err => {
				    console.log(err);
				})
			}
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/shop/activationList.vue